module.exports = __webpack_public_path__ + "images/ds-mw-banner-side.webp";